var _path, _path2, _path3, _polyline, _path4, _rect, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnsafrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "498px",
    height: "137.3px",
    viewBox: "0 0 498 137.3",
    enableBackground: "new 0 0 498 137.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M486.9,73.9H482l-2.1-6.1l-0.1-0.2c-0.8,0.4-1.5,0.7-1.8,0.8c-1.8,0.7-5.2,0.9-6-1.3c-0.3-0.8-0.2-1.5,0-2.2 c0.2-1.2,2.2-2.6,5-3.6l0.7-0.3L474,50.2l-8.2,23.7h-4.9L472,43.5h3.7l5.9,16c0,0,12.4,0.2,12.1,1c0,0.2-1,0.7-1,0.7 c-0.9,0.5-5.1,2.6-8.8,4.4L486.9,73.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M209.4,50.6c-3.2,8.7-16,13.6-22.4,16.5c-0.2,0.2,0.7,1.2,1.2,1.5c2.3,1.3,8.4,0.4,26-6.4 c8.2-3.2,16.1-8.8,26.3-9.8c4.1,4.9,2.4,0.9,0,7.6c6-2.7,7-4.4,17.2-3.2c13,1.6,19.3,14,32.3,7.7c10.3,0.5,2.3,9.7-6.6,8.9 c-10.7-1-14.1-7.4-26.4-9.7c-17.6-3.3-20.1,11.3-27.4,10c-0.8-0.2-3.4-0.6-3.2-4.3c0.1-1.1,3.8-5.2,4.2-7.3h-0.6 c-2.6,2-32.9,15.7-43.4,12.8c-3.3-0.9-6.4-3.3-6.9-4.7c-10.9,2-29.6,3.2-39.5,2.9c-25.4,0-77.6-1.5-102.1,0.1 c-3.5,0.2-14.9,0.9-18.2,1.1c-2.3,0.2-6.6,2.5-10.3,2.7c-2.6,0.1-4.2-1.4-5-2.7c-0.4-0.5-0.6-1.1-0.8-2c-0.1-0.8-0.1-1.7,0-2.5 c0.1-1,0.7-1.8,1-2.1c0.8-0.8,1.8-1.4,2.6-1.6c5.2-1.6,17.5-0.8,17.5-0.8l13.7-0.1c28.4,0.5,75.6,2.9,103.7,3 c17.8,0,36.7-2.1,36.4-2.8c0-0.5,0-1.4,0.1-2.3c1-8.5,5.1-14.1,12.8-17.7C208.8,37.6,210.6,48.3,209.4,50.6 M199,49.3 c-3.6,1-4.6,2.3-6.5,3.8c-1.7,1.3-2.4,2.8-3.8,4.4c-0.9,1.6-1.4,2.7-1.3,2.8c0.8,0.8,12.5-6,14.4-10.9C202.1,48.5,200,49,199,49.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#231F20",
    d: "M359.5,63.9h-9.4l4.7-13.5L359.5,63.9 M367.8,73.9l-11.2-30.4h-3.7 l-11.2,30.4h4.9l2.1-6.1h12l2.1,6.1H367.8z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#231F20",
    points: "391.6,47.6 391.6,43.5 372.1,43.5 372.1,73.9 376.7,73.9 376.7,61.1 389.4,61.1 389.4,56.9  376.7,56.9 376.7,47.6 391.6,47.6 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#231F20",
    d: "M413.7,52.4c0,3-2.1,4.7-5.2,4.7h-6.8v-9.5h6.8 C411.6,47.6,413.7,49.4,413.7,52.4 M419.3,73.9l-7-13.5c3.4-0.9,6.1-3.7,6.1-8.1c0-5.2-3.7-8.9-9.4-8.9h-11.8v30.4h4.6V61.1h5.8 l6.4,12.8H419.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 425.1,
    y: 43.5,
    fill: "#231F20",
    width: 4.6,
    height: 30.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M458.3,64.8h-4.7c-0.7,3.1-2.8,5.2-6.2,5.2c-1.8,0-3.4-0.7-4.5-1.8c-1.5-1.6-1.8-3.4-1.8-9.5 c0-6.1,0.3-7.9,1.8-9.5c1.1-1.2,2.7-1.8,4.5-1.8c3.4,0,5.4,2.1,6.2,5.2h4.7c-1.1-6.1-5.3-9.4-10.9-9.4c-3.2,0-5.9,1.2-8,3.2 c-3,3-2.9,6.4-2.9,12.2c0,5.9,0,9.2,2.9,12.2c2.1,2.1,4.8,3.2,8,3.2C453,74.2,457.3,70.9,458.3,64.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M311.8,31.5c-11.4,13.7-0.5,27.7,8.5,36.8c2.8,2.8,9.5,11.2,11.3,12.9c10,9.8,11.5,14.6,8.2,22.9 c-6.6,16.3-69.4,38.9-93.9,23.8c-2.6-1.6-4.4-3.8-3.3-7.2c1-3,7.7-9.4,11.7-11.7c12.2-7.3,21.4-12,35.8-17.1 c7.7-2.7,16.4-5.1,21.3-5.8c1.9-0.3,2.9,1,1.8,1.3c-3.4,0.9-28.2,10-49.6,22.5c-5.7,3.3-16,10.8-12.1,12.4 c26.2,10.4,75.5-11.7,79.5-23.3c3-8.7-25.4-29.4-30.9-42.7c-5.7-13.7,1.9-26.6,9.3-32.5c14.1-11.2,31.3-18.2,50.6-19.8 c5.7-0.5,6.5-0.6,7.4,0.2c2.5-0.9,5-2.3,7.4,0.6c-0.7,3.4-3.6,4.4-5.4,6.6c-1.9,0.3-2.8-1.4-3.7-2.3C342.2,5.5,321.3,20,311.8,31.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnsafrica);
export default __webpack_public_path__ + "static/media/ensafrica.b5b83d82bd42c78f26317fca1cb2353e.svg";
export { ForwardRef as ReactComponent };